import PortailStatsCardController from './portail.stats.card.controller';

export default {
    bindings: {
        stats: '<'
    },
    controller: PortailStatsCardController,
    template: require('./portail.stats.card.tpl.html')
};
